import { motion } from "framer-motion";
import { ArrowLeft, Loader2 } from "lucide-react";

interface WizardFooterProps {
    currentStep: number;
    totalSteps: number;
    onPrevious: () => void;
    onNext: () => void;
    onSubmit: () => void;
    isSubmitting?: boolean;
}

const WizardFooter = ({
    currentStep,
    totalSteps,
    onPrevious,
    onNext,
    onSubmit,
    isSubmitting = false
}: WizardFooterProps) => (
    <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center">
        <motion.button
            whileHover={{ scale: isSubmitting ? 1 : 1.05 }}
            whileTap={{ scale: isSubmitting ? 1 : 0.95 }}
            onClick={onPrevious}
            disabled={currentStep === 0 || isSubmitting}
            className={`p-3 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors duration-200 ${(currentStep === 0 || isSubmitting) ? 'opacity-50 cursor-not-allowed' : ''
                }`}
        >
            <ArrowLeft className="w-5 h-5" />
        </motion.button>
        <div>
            {currentStep < totalSteps - 1 && (
                <button
                    onClick={onNext}
                    disabled={isSubmitting}
                    className={`bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition-colors duration-200 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                    Siguiente
                </button>
            )}
            {currentStep === totalSteps - 1 && (
                <button
                    onClick={onSubmit}
                    disabled={isSubmitting}
                    className={`bg-green-500 text-white p-3 rounded-lg hover:bg-green-600 transition-colors duration-200 flex items-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                    {isSubmitting ? (
                        <>
                            <Loader2 className="w-5 h-5 animate-spin" />
                            <span>Creando...</span>
                        </>
                    ) : (
                        <span>Crear Meta</span>
                    )}
                </button>
            )}
        </div>
    </div>
);

export default WizardFooter;